import React, { useState, useEffect } from "react";
import { Table, Button, Card, Container, Row, Col, Spinner, Alert } from "react-bootstrap";
import DriverService from "../../services/DriverService";
import "./style.css";

const ChuyenBaoduongSuachua = () => {
    const [chuyenData, setChuyenData] = useState([
        {
            id: 'SA0123',
            bien_kiem_soat: "51A-12345",
            ngay_sua_chua: "2024-02-28T08:00:00Z",
            loai: "Bảo dưỡng định kỳ",
            vai_tro: "Gửi xe",
            tram: "Trạm bảo dưỡng Quận 1",
            loai_xe: "Xe tải",
            trang_thai: "",
        },
        {
            id: 'BA0123',
            bien_kiem_soat: "51B-67890",
            ngay_sua_chua: "2024-02-27T14:30:00Z",
            loai: "Sửa chữa động cơ",
            vai_tro: "Lấy xe",
            tram: "Trạm bảo dưỡng Quận 7",
            loai_xe: "Xe khách",
            trang_thai: "Đã nhận nhiệm vụ",
        }
    ]);
    
    const [loading, setLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await DriverService.getAllChuyenBaoduong();
                setChuyenData(response.data);
            } catch (error) {
                setErrorMessage("Lỗi khi tải dữ liệu! Vui lòng thử lại.");
                console.error("Fetch error:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    const handleChapNhan = async (id) => {
        const updates = chuyenData.map(async (chuyen) => {
            if (chuyen.id === id) {
                let newTrangThai = chuyen.trang_thai;
    
                if (!chuyen.trang_thai) {
                    newTrangThai = "Đã nhận nhiệm vụ";
                } else if (chuyen.trang_thai === "Đã nhận nhiệm vụ") {
                    newTrangThai = "Hoàn thành";
                } else {
                    return chuyen; // No change
                }
    
                try {
                    console.log(`Fetching API: Updating chuyen ${id} to "${newTrangThai}"`);
                    const response = await DriverService.updateBdSc(id, chuyen.vai_tro, newTrangThai);
                    alert(response.message || 'Đã gửi dữ liệu thành công');
                } catch (error) {
                    console.error('Lỗi khi gửi dữ liệu:', error);
                    alert('Không thể gửi dữ liệu sửa chữa và bảo dưỡng. ' + error.message);
                }
    
                return { ...chuyen, trang_thai: newTrangThai }; // Return updated object
            }
            return chuyen;
        });
    
        // Wait for all async operations to finish before updating state
        const updatedData = await Promise.all(updates);
        setChuyenData(updatedData);
    };
    

    const handleHuyChuyen = async (id) => {
        const updates = chuyenData.map(async (chuyen) => {
            if (chuyen.id === id) {
                const newTrangThai = "Hủy";
    
                try {
                    console.log(`Fetching API: Updating chuyen ${id} to "Hủy"`);
                    const response = await DriverService.updateBdSc(id, chuyen.vai_tro, newTrangThai);
                    alert(response.message || 'Đã hủy chuyến thành công');
                } catch (error) {
                    console.error('Lỗi khi gửi dữ liệu:', error);
                    alert('Không thể hủy chuyến. ' + error.message);
                }
    
                return { ...chuyen, trang_thai: newTrangThai };
            }
            return chuyen;
        });
    
        const updatedData = await Promise.all(updates);
        setChuyenData(updatedData);
    };
    

    if (loading) {
        return (
            <Container className="text-center mt-5">
                <Spinner animation="border" />
                <p>Đang tải dữ liệu...</p>
            </Container>
        );
    }

    return (
        <Container fluid className="mt-4 ChuyenBaoduongSuachuaComponent">
            <h2>Danh sách chuyến xe đi Bảo dưỡng - Sửa chữa</h2>

            {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}

            <Row xs={1} sm={2} md={3} lg={3} xl={4} className="g-4">
                {chuyenData.map((chuyen) => (
                    <Col key={chuyen.id}>
                        <Card>
                            <Card.Body style={{ textAlign: "center" }}>
                                <Card.Title className="text-center fw-bold">
                                    Mã Chuyến: {chuyen.id}
                                </Card.Title>
                                <Card.Text>Biển kiểm soát: {chuyen.bien_kiem_soat}</Card.Text>
                                <Card.Text>Ngày sửa chữa: {new Date(chuyen.ngay_sua_chua).toLocaleDateString()}</Card.Text>
                                <Card.Text>Loại: {chuyen.loai}</Card.Text>
                                <Card.Text>Nhiệm vụ: {chuyen.vai_tro}</Card.Text>
                                <Card.Text>Điểm đến: {chuyen.tram}</Card.Text>
                                <Card.Text>Loại xe: {chuyen.loai_xe}</Card.Text>

                                <div className="d-flex gap-2 justify-content-between mt-3">
                                    <Button
                                        variant={chuyen.trang_thai === "Đã nhận nhiệm vụ" ? "success" : "primary"}
                                        disabled={chuyen.trang_thai === "Hủy" || chuyen.trang_thai === "Hoàn thành"}
                                        onClick={() => handleChapNhan(chuyen.id)}
                                    >
                                        {!chuyen.trang_thai ? "Chấp nhận chuyến" : "Hoàn thành" }
                                    </Button>

                                    <Button
                                        variant="danger"
                                        disabled={chuyen.trang_thai === "Hoàn thành"}
                                        onClick={() => handleHuyChuyen(chuyen.id)}
                                    >
                                        Hủy chuyến
                                    </Button>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
        </Container>
    );
};

export default ChuyenBaoduongSuachua;
